import { z } from 'zod/v4';
import { createDefinitionSchema } from '../utils/helpers';

export type MonitorDatasource = z.infer<typeof monitorDatasourceSchema>;
const monitorDatasourceSchema = z.enum(['GRAPHITE', 'LOGGING', 'PROMETHEUS']);

export type MonitorAlertState = z.infer<typeof alertStateSchema>;
const alertStateSchema = z.enum([
  'CRITICAL',
  'DOWNTIMED',
  'FIRING',
  'INACTIVE',
  'PASS',
  'PENDING',
  'UNKNOWN',
  'WARNING',
  '',
]);

export type MonitorQuerySpec = z.infer<typeof monitorQuerySpecSchema>;
export const monitorQuerySpecSchema = z.object({
  slug: z.string(),
  datasource: monitorDatasourceSchema,
  alert_state: alertStateSchema.optional(),
  signal: z.string(),
  query: z.string().optional(),
  include_thresholds: z.boolean().optional(),
});

export type MonitorQueryDefinition = z.infer<typeof monitorQueryDefinitionSchema>;
export const monitorQueryDefinitionSchema = createDefinitionSchema('MonitorDataQuery', monitorQuerySpecSchema);
